export const commaizeNumber = (num: number): string => {
  return num.toLocaleString();
};
